import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=662172b7&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=ts"
export * from "./Certifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662172b7",
  null
  
)

export default component.exports